import styled from 'styled-components';

export const LoadMoreWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.black3};

  button {
    color: ${({ theme }) => theme.colors.green7};
    font-weight: 500;

    &:hover {
      color: ${({ theme }) => theme.colors.green6};
    }
  }
`;
